import LOCALES from '../locales';

export default {
  [LOCALES.ENGLISH]: {
    emailAddress: 'Email address',
    password: 'Password',
    submit: 'Submit',
    register: 'Register',
    home: 'Home',
    aboutUs: 'About us',
    services: 'Services',
    otherServices: 'Services',
    structure: 'Structure',
    members: 'Membership',
    ourMemebers: 'Our members',
    becomeMember: 'Become a member',
    projects: 'Projects',
    documents: 'Documents',
    media: 'Media',
    news: 'News',
    send: 'Send',
    message: 'Message',
    title: 'Title',
    yourName: 'Your name',
    allNews: 'See all news',
    ourGoals: 'Our goals',
    benefits: 'Services and benefits',
    login: 'Login',
    ourMission: 'Our mission',
    ourVision: 'Our vision',
    organisationStructure: 'Organizational Structure',
    downloadApplication: 'Download membership application',
    readMore: 'Read more',
    companiesByRegion: 'Our members by regions of Serbia',
    ourMembers: 'Our members',
    location: 'Location',
    contact: 'Contact',
    requiredField: 'Field is required!',
    contactData: 'Contact data',
    companyData: 'Company data',
    aboutUsHome:
      'Business association for improving the competitiveness of the metal sector of Serbia and the most significant association of metalworkers in Serbia.',
    vmc: 'Vojvodina Metal Cluster (VMC)',
    rsedp2: ' RSEDP2',
    economicDevelopment: ' razvoja privrede',
    partnership: 'partnerstvo',
    fastDevelopment: ' brzog razvoja i brze proizvodnje.',
    everyday: 'Svakodnevno',
    competitiveness: ' doprinosimo povećavanju konkurentnosti',
    concurrency: 'Povećanje konkurentnost',
    infrastructure: 'Razvijamo poslovnu infrastrukturu',
    employment: ' održivom zapošljavanju',
    increaseEmployment: ' povećanju zaposlenosti ',
    contribution: 'Doprinos',
    education: ' edukacija i obuka ',
    voteRight: 'stiču pravo glasa',
    obligations: 'obaveze',
    rights: 'prava',
    aboutUsPage1:
      ' poslovno udruženje za unapređenje konkurentnosti metalskog sektora Vojvodine / Srbije i najznačajnija asocijacija metalaca u Srbiji.{tag} VMC je osnovan u Temerinu 2011. godine od strane 76 osnivača (56 su privatne proizvodne komapnije i 20 su institucije za podršku). Od 2013. godine broj naših članova je 113 (93 preduzeća + 20 institucija) od čega: 85,5 % je iz AP Vojvodine, 7,5 % iz ostalih delova Republike Srbije i 7% iz zemalja EU (domaće kompanije sa većinskom vlasničkom strukturom poreklom iz EU). Od tada broj članova raste.{tag} VMC je nastao kao jedan od ključnih rezultata istoimenog projekta koji je realizovan uz finansijsku podršku EU (kroz program',
    aboutUsPage2:
      ' . Projekat je podržala Vlada AP Vojvodine. Klaster je potpuno bio povezan sa projektom do završetka projekta 28.05.2013. godine. Od tada klaster se organizaciono i finansijski potpuno osamostalio.{tag} Klastersko umrežavanje predstavlja najznačajniju strategiju',
    aboutUsPage3:
      '  i uspešno se primenjuju u razvijenim zemljama. EU je razvoj klastera uvrstila u svoje strateške pravce delovanja 2014-2020, ali poseban značaj i rezultate ima primena ove strategija na zemlje u tranziciji, kakva je nasa zemlja. Po prirodi klasteri predstavljaju ',
    aboutUsPage4:
      ' : preduzeća, organa uprave i institucija podrške (univerziteta), zasnovano na principu fleksibilne specijalizacije, gde svako radi ono što ume najbolje i za šta ima dobre uslove i predstavljaju osnovu za ostvarenje koncepta',
    ourMissionHome:
      'Moćan, organizovan, izvozno orjentisan metalski sektor Srbije čija je konkurentnost na globalnom tržištu zasnovana na vrhunskom kvalitetu proizvoda, svetskim standardima, inovativom znanju, visokim tehnologijama, ekološki čistoj i održivoj proizvodnji.',
    ourMissionPage1:
      ' je moćan, organizovan, izvozno orjentisan metalski sektor Srbije čija je konkurentnost na globalnom tržištu zasnovana na vrhunskom kvalitetu proizvoda, svetskim standardima, inovativom znanju, naprednim tehnologijama, ekološki čistoj i održivoj proizvodnji. Našoj viziji svakodnevno težimo i radimo na njenom ostvarenju.',
    ourMissionPage2:
      ' je da stvaramo uslove za efektivno i efikasno poslovanje svakog člana Vojovidina Metal Cluster-a kroz povezivanje i zajedničko delovanje preduzeća, organa uprave i naučno-istraživačkih i inovativnih institucija.',
    ourMissionPage3:
      ' metalskog sektora kroz podršku članovima, putem transfera znanja, podizanja inovativnih potencijala i poboljšavanja njihove internacionalizacije.',
    ourMissionPage4:
      ' klastera ka organizovanoj, sistematskoj, visoko profesionalnoj i snažnoj podršci kompanijama metalskog sektora u unapređivanju konkurentnosti na globalnom tržištu, obezbeđenju vidljivosti i čvrstog regionalnog povezivanja.',
    ourMissionPage5:
      'Promoteri smo pozitivnog imidža metaske industrije i njene vidljivosti.',
    ourGoals1:
      ' u Srbiji kroz promociju javno-privatnog partnerstva, povećanje konkurentnosti i podizanje izvoznih performansi kompanija u metalskom kompleksu.',
    ourGoals2:
      ' MSP metalskog sektora, kroz unapređenje institucionalnih kapaciteta klastera, u pružanju usluga u oblasti tehnoloških inovacija, sertifikacije kvaliteta i proizvoda, obuka zaposlenih, kao i u marketingu /internacionalizaciji i usvajanju EU standarda.',
    ourGoals3:
      'Razviti Klaster centre izvrsnosti koji će u sebi objedinjavati interdisciplinarna znanja i obezbediti održivost koncepta putem',
    ourGoals4:
      ' univerzitetskog osoblja i predstavnika institucija u skladu sa potrebama privrede, studenata i zaposlenih u preduzećima u pogledu zajedničkog delovanja i razvoja i kroz poboljšanje postojećih nastavnih planova i programa praktično usmerenim znanjima prema privredi.',
    ourGoals5:
      'Pružiti podršku i biti partner Vladi Republike Srbije i Vladi AP Vojvodine u razvoju i sprovođenju efektivnih mehanizama i instrumenata podrške, usmerenih ka',
    ourGoals6:
      'i unapređenju konkurentnosti MSP metalskog sektora kroz razvoj klastera i promociju izvoza.',
    ourServices1:
      'Vojvodina Metal Cluster - VMC, nastao je kao inicijativa kompanija iz metalskog sektora u Vojvodini, i to je osnovna snaga i vrednost ovog klastera. Svako zainteresovano preduzeće iz oblasti metalskog sektora može postati član, i time uživati u posebnim beneficijama i uslugama.',
    ourServices2: 'Ulaskom u VMC, svi članovi ',
    ourServices3: ' kao i određene ',
    ourServices4: ' ali i ',
    ourServices5: ' u skladu sa Statutom klastera, na primer:',
    board1: 'Predsednik skupštine',
    board2: 'Potpredsednici skupštine:',
    board3: 'Upravni odbor:',
    board4: 'Nadzorni odbor:',
    board5: 'Savet VMC-a:',
    board6: 'Menadžer klastera:',
    projectName: 'Project name',
    projectValue: 'Project value',
    donor: 'Donor',
    projectGoal: 'Project goal',
    projectDuration: 'Project duration',
    status: 'Status',
    from: 'From',
    to: 'To',
    finished: 'Finished',
    inProgress: 'In progress',
    nationalProjects: 'National Projects',
    internationalProjects: 'International Projects',
    vmcClinic: 'VMC Clinic',
    vcmInovationPull: 'VMC Inovation Pull',
    vmcBusinessForum: 'VMC Business Forum',
    vmcCatalog: 'VMC Catalog',
    vmcPresentation: 'VMC Presentation',
    vmcAcademy: 'VMC Academy',
    vmcInovationHub: 'VMC Inovation Hub',
    ePlatform: 'E-platform for distance learning',
    norwayForYou: 'Norway For You'
  }
};
